export { default } from './TagLabel';
